import React, { PropTypes } from 'react';
import { Accordion } from 'semantic-ui-react';
import { getTabsToRender, tabLabel } from '../../../../common/tasks';
import Task from './Task';
import RatDiagnosis from './RatDiagnosis';
import InsectDiagnosis from './InsectDiagnosis';
import OtherDiagnosis from './OtherDiagnosis';
import AnnexDiagnosis from './AnnexDiagnosis';

class Site extends React.Component {
  render() {
    const {
      site,
      siteDiagnosis,
      toggleTask,
      timeUnits,
      infestationLevels,
      infraTypes,
      ratSpecies,
      contractTypes,
      insectSpecies,
      insectTreatments,
      otherSpecies,
      otherTreatments,
      annexConf,
      startIndex,
      activeIndex,
      handleClick,
      dirty,
      placesRef,
      accessibilityRef,
    } = this.props;

    const onToggle = taskCode => () => {
      toggleTask(taskCode);
    };

    const onValueChanged = task => propName => (evt, data) => {
      this.props.onChange(task, propName, data.value);
    };

    const taskComponent = task => {
      switch (task) {
        case 'RAT':
          return (
            <RatDiagnosis
              onValueChange={onValueChanged(task)}
              taskDiagnosis={siteDiagnosis[task] || {}}
              timeUnits={timeUnits}
              infestationLevels={infestationLevels}
              infraTypes={infraTypes}
              ratSpecies={ratSpecies}
              contractTypes={contractTypes}
              dirty={dirty}
              placesRef={placesRef}
              accessibilityRef={accessibilityRef}
            />
          );
        case 'INSECT':
          return (
            <InsectDiagnosis
              onValueChange={onValueChanged(task)}
              taskDiagnosis={siteDiagnosis[task] || {}}
              timeUnits={timeUnits}
              infestationLevels={infestationLevels}
              infraTypes={infraTypes}
              insectSpecies={insectSpecies}
              insectTreatments={insectTreatments}
              contractTypes={contractTypes}
              dirty={dirty}
              placesRef={placesRef}
              accessibilityRef={accessibilityRef}
            />
          );
        case 'OTHER_PESTS':
          return (
            <OtherDiagnosis
              onValueChange={onValueChanged(task)}
              taskDiagnosis={siteDiagnosis[task] || {}}
              timeUnits={timeUnits}
              infestationLevels={infestationLevels}
              infraTypes={infraTypes}
              otherSpecies={otherSpecies}
              otherTreatments={otherTreatments}
              contractTypes={contractTypes}
              dirty={dirty}
              placesRef={placesRef}
              accessibilityRef={accessibilityRef}
            />
          );
        case 'ANNEX_1':
          const {
            annex1SimpleList1,
            annex1SimpleList2,
            annex1ComplexList,
          } = this.props;

          return (
            <AnnexDiagnosis
              taskDiagnosis={siteDiagnosis[task] || {}}
              onValueChange={onValueChanged(task)}
              timeUnits={timeUnits}
              contractTypes={contractTypes}
              conf={annexConf.ANNEX_1}
              simpleList1Ref={annex1SimpleList1}
              simpleList2Ref={annex1SimpleList2}
              complexListRef={annex1ComplexList}
              dirty={dirty}
            />
          );

        case 'ANNEX_2':
          const {
            annex2SimpleList1,
            annex2SimpleList2,
            annex2ComplexList,
          } = this.props;

          return (
            <AnnexDiagnosis
              taskDiagnosis={siteDiagnosis[task] || {}}
              onValueChange={onValueChanged(task)}
              timeUnits={timeUnits}
              contractTypes={contractTypes}
              conf={annexConf.ANNEX_2}
              simpleList1Ref={annex2SimpleList1}
              simpleList2Ref={annex2SimpleList2}
              complexListRef={annex2ComplexList}
              dirty={dirty}
            />
          );

        default:
          return <div />;
      }
    };

    return (
      <div style={{ paddingBottom: '25px' }}>
        <div className="ui segment">
          <div className="ui header">
            <span>Site : {site.name}</span>
            {site.study_id && (
              <a
                href={`/pco-manager/interventions/generality/${site.study_id}`}
                target="_blank"
                className="ui right floated tiny button teal"
              >
                Etude
              </a>
            )}
          </div>
        </div>
        <Accordion styled fluid>
          {getTabsToRender(site).map((taskCode, index) => (
            <Task
              key={taskCode}
              index={index + startIndex}
              currentIndex={activeIndex}
              activated={false}
              title={tabLabel(taskCode)}
              handleClick={handleClick}
              onToggle={onToggle(taskCode)}
              taskDiagnosis={siteDiagnosis[taskCode] || {}}
            >
              {taskComponent(taskCode)}
            </Task>
          ))}
        </Accordion>
      </div>
    );
  }
}

Site.propTypes = {
  site: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  toggleTask: PropTypes.func.isRequired,
  siteDiagnosis: PropTypes.object.isRequired,
  timeUnits: PropTypes.array.isRequired,
  infestationLevels: PropTypes.array.isRequired,
  infraTypes: PropTypes.array.isRequired,
  ratSpecies: PropTypes.array.isRequired,
  contractTypes: PropTypes.array.isRequired,
  insectSpecies: PropTypes.array.isRequired,
  insectTreatments: PropTypes.array.isRequired,
  otherSpecies: PropTypes.array.isRequired,
  otherTreatments: PropTypes.array.isRequired,
  annexConf: PropTypes.object.isRequired,
  annex1SimpleList1: PropTypes.array.isRequired,
  annex1SimpleList2: PropTypes.array.isRequired,
  annex1ComplexList: PropTypes.array.isRequired,
  annex2SimpleList1: PropTypes.array.isRequired,
  annex2SimpleList2: PropTypes.array.isRequired,
  annex2ComplexList: PropTypes.array.isRequired,
  startIndex: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default Site;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/Site.js